import { getTimeRemaining } from 'utilities/date';

function renderDynamicSaleCountdown (element, endtime) {

	const formatCountdown = (t) => {

		const formattedTime = {
			days: t.days > 0 ? `${t.days} ${t.days > 1 ? 'Days' : 'Day'}` : '',
			hours: t.hours > 0 ? `${t.hours < 10 ? '0' : ''}${t.hours}:` : '',
			minutes: t.minutes > 0 ? `${t.minutes < 10 ? '0' : ''}${t.minutes}:` : '',
			seconds: t.seconds < 10 ? `0${t.seconds}` : t.seconds
		};

		// do not drop minutes if minutes remaining is 0, but hours remaining is more than 0, instead show "00"
		if (t.hours > 0 && t.minutes === 0) {

			formattedTime.minutes = '00:';

		}

		const {
			days, hours, minutes, seconds
		} = formattedTime;

		return `Sale Ends in ${days} ${hours}${minutes}${seconds}`;

	};

	const initializeClock = () => {

		const countDownElement = element;
		let timeinterval;

		const updateClock = () => {

			const timeRemaining = getTimeRemaining(endtime);
			countDownElement.innerHTML = formatCountdown(timeRemaining);

			if (timeRemaining.total <= 0) {

				clearInterval(timeinterval);
				countDownElement.innerHTML = 'Sale Has Ended';

			}

		};

		updateClock();
		timeinterval = setInterval(updateClock, 1000);

	};

	if (!element) {

		return;

	}

	initializeClock();

}

export default renderDynamicSaleCountdown;
